import * as yup from 'yup';

type FileInputValue = File | { id: number; url: string };

export const filterSetFormSchema = yup.object({
    title: yup.string().required('Название обязательно'),
    description: yup.string().optional(),
    image: yup
        .mixed<FileInputValue>()
        .optional()
        .nullable()
        .test('fileSize', 'Размер файла не должен превышать 10MB', (value) => {
            if (!value || !(value instanceof File)) return true;
            return value.size <= 10 * 1024 * 1024;
        })
        .test('fileType', 'Разрешены только изображения (JPEG, PNG, WebP)', (value) => {
            if (!value || !(value instanceof File)) return true;
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            return allowedTypes.includes(value.type);
        }),
}) as yup.ObjectSchema<{ title: string; description?: string; image?: FileInputValue | null }>;

